import './Loading.scss'


export default function Loading({ className, minHeight, maxWidth }) {

  return <div
    className={"bw-loading" + (className ? ` ${className}` : "")}
    style={{ minHeight, maxWidth }}
  >
    <div><div /></div>
    <div><div /></div>
    <div><div /></div>
    <div><div /></div>
  </div>
}

export function AppLoading() {

  return <div className="bw-app-loading">
    <Loading />
  </div>
}
